export interface ApiError {
  status: number;
  message: string;
}

function getToken(): string | null {
  return localStorage.getItem('aadpa_token');
}

export async function api<T = unknown>(
  path: string,
  opts: { method?: string; body?: unknown; auth?: boolean } = {},
): Promise<T> {
  const headers: Record<string, string> = {};
  if (opts.body !== undefined) headers['content-type'] = 'application/json';
  if (opts.auth !== false) {
    const token = getToken();
    if (token) headers['authorization'] = `Bearer ${token}`;
  }
  const res = await fetch(`/api/${path}`, {
    method: opts.method ?? (opts.body !== undefined ? 'POST' : 'GET'),
    headers,
    body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
  });
  if (!res.ok) {
    let message = res.statusText;
    try {
      const data = await res.json();
      if (data?.error) message = data.error;
    } catch {
      /* ignore */
    }
    throw { status: res.status, message } as ApiError;
  }
  return res.json() as Promise<T>;
}
